import { render } from "./OrderRowMessage.vue?vue&type=template&id=349ec84e&scoped=true"
import script from "./OrderRowMessage.vue?vue&type=script&lang=js"
export * from "./OrderRowMessage.vue?vue&type=script&lang=js"

import "./OrderRowMessage.vue?vue&type=style&index=0&id=349ec84e&scoped=true&lang=css"

import exportComponent from "/Users/fredde/programvara/boove.se/w3.boove.se/w3.boove.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-349ec84e"]])

export default __exports__